import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MenuItem } from "primeng/api/menuitem";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Component({
  selector: "admin-panel",
  templateUrl: "./admin-panel.component.html",
  styleUrls: ["./admin-panel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AdminPanelComponent implements OnInit {
  items: MenuItem[];

  constructor(private translate: TranslateService, private router: Router) {}

  ngOnInit(): void {
    this.initMenu();
    this.translate.onLangChange.subscribe((lang) => {
      this.initMenu();
    });
  }

  private initMenu(): void {
    this.translate
      .get([
        "admin",
        "all_added_notes",
        "invoices",
        "order_management_header",
        "users",
        "notes_list_category_menu",
        "information_pages",
        "invoice_details",
        "data_export",
        "prepaid_codes_header",
        "contract_details",
        "orders",
        "contracts",
        "zaiks_report_menu",
        "admin_newsletter",
      ])
      .subscribe((t) => {
        setTimeout(() => {
          this.items = [
            {
              label: t.admin,
              items: [
                {
                  label: t.order_management_header,
                  routerLink: "/administrator-panel/orders-management",
                },
                {
                  label: t.invoices,
                  routerLink: "/administrator-panel/invoices",
                },
                {
                  label: "Doładowania konta",
                  routerLink: "/administrator-panel/prepaid-invoices",
                },
                {
                  label: t.all_added_notes,
                  routerLink: "/administrator-panel/notes-download",
                },
                {
                  label: t.users,
                  routerLink: "/administrator-panel/all-users",
                },
                {
                  label: t.contracts,
                  routerLink: "/administrator-panel/contracts",
                },
                {
                  label: t.notes_list_category_menu,
                  routerLink: "/administrator-panel/categories",
                },
                {
                  label: t.information_pages,
                  routerLink: "/administrator-panel/information-pages",
                },
                {
                  label: t.invoice_details,
                  routerLink: "/administrator-panel/invoice-data",
                },
                {
                  label: t.contract_details,
                  routerLink: "/administrator-panel/contract-data",
                },
                {
                  label: t.data_export,
                  routerLink: "/administrator-panel/data-export",
                },
                {
                  label: t.prepaid_codes_header,
                  routerLink: "/administrator-panel/prepaids",
                },
                {
                  label: t.zaiks_report_menu,
                  routerLink: "/administrator-panel/zaiks-report",
                },
                {
                  label: t.admin_newsletter,
                  routerLink: "/administrator-panel/newsletter",
                },
              ],
            },
          ];
        }, 100);
      });
  }
}
